import React from 'react';
import { connect } from 'react-redux';
import { setFontSizeCoefThunk } from '@/actions';
import WebComponentApp from './web_component';

const AppContainer = props => {
  const { platform, setFontSizeCoefThunk } = props;

  React.useEffect(() => {
    setFontSizeCoefThunk();
  }, [platform.config.environment]);

  return <WebComponentApp />;
};

const mapStateToProps = state => ({
  platform: state.core.platform,
})

const mapDispatchToProps = dispatch => ({
  setFontSizeCoefThunk: () => dispatch(setFontSizeCoefThunk()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
